export {NewPagination} from './NewPagination';
export {type PaginationResponsiveConfig} from './types';
export {withPaginationSuffix} from './utils/makeGetHref';
